import React from 'react';
import {Input as InputStyled, InputStyledAppWeb, Label} from '../../../assets/styles/GlobalStyles';
import {getStyles} from '../../../utils/getStyles';

export const Input = ({field, form, label, ...props}) => {
    return (
        <>
            {label && (
                <Label htmlFor={field.name} disabled={props.disabled}>
                    {label}
                </Label>
            )}
            {!props.isAppWeb ?
                <InputStyled
                    style={form ? getStyles(form.errors, field.name) : {}}
                    autoCorrect="off"
                    autoCapitalize="none"
                    onChange={(e, value) => {
                        console.log(e, value);
                    }}
                    {...field}
                    {...props}
                />
                :
                <InputStyledAppWeb
                    style={form ? getStyles(form.errors, field.name) : { color: '#FFF' }}
                    autoCorrect="off"
                    autoCapitalize="none"
                    placeholder={props.placeholder}
                    onChange={(e, value) => {
                        console.log(e, value);
                    }}
                    {...field}
                    {...props}
                />
            }
        </>
    );
};
